import type { $Fetch } from 'ofetch';
import type { LgpdAdminGateway, ListLgpdSolicitacoesParams } from '@/application/port/out/LgpdAdminGateway';
import type { LgpdSolicitacao, ProcessarLgpdSolicitacaoCommand } from '@/domain/model/Lgpd';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/**
 * HTTP gateway do admin LGPD (fila do DPO) — `/api/v1/admin/lgpd/solicitacoes`.
 *
 * @since LgpdAdmin (reaberto — backend expôs o GET em 2026-06-11)
 */
export class HttpLgpdAdminGateway implements LgpdAdminGateway {
  private readonly base = '/api/v1/admin/lgpd/solicitacoes';
  constructor(private readonly client: $Fetch) {}

  async listSolicitacoes(params: ListLgpdSolicitacoesParams): Promise<Page<LgpdSolicitacao>> {
    const query: Record<string, string | number> = { page: params.page ?? 0, size: params.size ?? 50 };
    if (params.status) query.status = params.status;
    const res = await this.client<ApiResponse<Page<LgpdSolicitacao>>>(
      this.base, { method: 'GET', params: query });
    assertApiSuccess(res);
    return res.data;
  }

  async processar(id: string, cmd: ProcessarLgpdSolicitacaoCommand): Promise<LgpdSolicitacao> {
    const res = await this.client<ApiResponse<LgpdSolicitacao>>(
      `${this.base}/${encodeURIComponent(id)}/processar`, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }
}
